// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4950":"19ec580f","5684":"19ec580f","5842":"df8f2af1","6196":"19ec580f","9516":"df8f2af1"}[chunkId] + ".chunk.css";
};